import type { ReactNode } from 'react'

interface Props {
    label: string
    required?: boolean
    children: ReactNode
}

/**
 * Поле картки, яке малює не ядровий `FormField`, а власний компонент
 * (перемикач активності, перемикачі ролей у формі створення).
 *
 * Розмітка — та сама, що в Ship-шаблоні поля (`Ship/Templates/Form/BaseFieldTemplate`):
 * підпис стоїть там само й виглядає так само, як у сусідніх полів, а e2e
 * знаходить поле за підписом тим самим локатором (`helpers/ui.formField`).
 */
export const CardField = ({ label, required = false, children }: Props) => (
    <div className="form-field form-field-default">
        <label className="field-label">
            {required ? <span className="field-required">*</span> : null}
            <h2 className="field-label-title">{label}</h2>
        </label>
        {children}
    </div>
)
